


























import Vue from 'vue'
import { IOrder, IStateOrder } from '@/models'
import { BaseContentContainer } from '@/components'
import {
    OrderAddress,
    OrderContactData,
    OrderShippingForm,
    OrderPaymentForm,
    OrderActions,
} from './components'
import { createNamespacedHelpers } from 'vuex'
import { STORE_MODULES } from '@/enums'

const { mapState } = createNamespacedHelpers(STORE_MODULES.ORDER)

export default Vue.extend({
    name: 'Order',

    components: {
        BaseContentContainer,
        OrderAddress,
        OrderContactData,
        OrderShippingForm,
        OrderPaymentForm,
        OrderActions,
    },

    props: {
        order: {
            type: Object as () => IOrder,
            required: true,
        },
    },

    computed: {
        ...(mapState([
            'shippingAddress',
            'shippingContactData',
            'shipping',
            'paymentMethod',
        ]) as MapStateToComputed<IStateOrder>),
    },
})
